<template>
  <div>
    <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
      <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
      <span>
        <w-lfour-session-settings-button class="cmp-margin-right" @reload-data="loadData"/>
        <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
      </span>
    </el-row>
    <el-row>
      <el-table-wrapper v-loading="loading" border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool"
        ref="table" style="width:100%;" :pagination="true" :column-default="columnDefault" :row-class-name="setRowClassName"
        row-key="seq" :tree-props="{children: 'slbRealConfigurationList'}" @expand-change="onClickExpandTable"
        @load-local-data="onLoadLocalData">
        <template #sessions-ratio-slot="scope">
          <el-progress v-if="scope.row.sessionsRatio >= 0" :text-inside="true" :stroke-width="18" :percentage="convertPercentageValue(scope.row.sessionsRatio)"></el-progress>
          <span v-else> - </span>
        </template>
        <template #session-userate-slot="scope">
          <el-progress v-if="scope.row.sessionUserate >= 0" :text-inside="true" :stroke-width="18" :percentage="convertPercentageValue(scope.row.sessionUserate)"></el-progress>
          <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
        </template>
        <template #convert-status-slot="scope">
          <!-- 가상-->
          <span v-if="scope.row.slbRealConfigurationList">
            <span v-if="scope.row.convertStatusValue === 'G'">
              <span :class="[$style['lfour-status'], $style['status-up']]"></span>
            </span>
            <span v-else-if="scope.row.convertStatusValue === 'O'">
              <span :class="[$style['lfour-status'], $style['status-mix']]"></span>
            </span>
            <span v-else-if="scope.row.convertStatusValue === 'R'">
              <span :class="[$style['lfour-status'], $style['status-down']]"></span>
            </span>
          </span>
          <!-- 물리  -->
          <el-tooltip v-else-if="scope.row.convertStatusValue === 'G'" effect="dark" placement="bottom">
            <span :class="[$style['lfour-status'], $style['status-up']]"></span>
            <span slot="content">{{scope.row.statusValue}}</span>
          </el-tooltip>
          <el-tooltip v-else-if="scope.row.convertStatusValue === 'O'" effect="dark" placement="bottom">
            <span :class="[$style['lfour-status'], $style['status-mix']]"></span>
            <span slot="content">{{scope.row.statusValue}}</span>
          </el-tooltip>
          <el-tooltip v-else-if="scope.row.convertStatusValue === 'R'" effect="dark" placement="bottom">
            <span :class="[$style['lfour-status'], $style['status-down']]"></span>
            <span slot="content">{{scope.row.statusValue}}</span>
          </el-tooltip>
        </template>
        <!-- 세션개수, CPS, Bps IN/OUT, pps IN/OUT 기간 차트 제공 -->
        <template v-for="column in chartValueColumns" slot-scope="scope" :slot="column.scopedSlot">
          <span v-if="lfourDataCheck(scope.row[column.id])" class="link c-pointer" @click="onShowChartPopup(scope.row, column.rscId)">
            <span v-if="scope.row[column.unit] === 'bytes'">
              {{convertBytesValue(scope.row[column.id])}}
            </span>
            <span v-else-if="scope.row[column.unit] === 'count'">
              {{convertCountValue(scope.row[column.id])}}
            </span>
            <span v-else>{{scope.row[column.id]}}</span>
          </span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-resource-compare-period-popup ref="comparePeriodPopup" :rsc-info-list="comparePeriodRscInfoList"/>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import forEach from 'lodash/forEach';
import { columnDefault } from '@/constants/table';
import WLfourSessionSettingsButton from '@/views/performance/node/analysis/netdevice/components/button/LfourSessionSettingsButton';
import { analysisTimeType } from '@/constants/performance';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import WResourceComparePeriodPopup from '@/components/popup/ResourceComparePeriodPopup';

// 세션 개수, CPS, BPS, PPS 관련 기간 차트 제공 요청 - (2020. 03. 02 - Song)
const chartValueColumns = [
  { id: 'currentSessions', scopedSlot: 'current-sessions-slot', unit: 'count', rscId: 'CURRENT_SESSIONS' },
  { id: 'sessionsPerSecond', scopedSlot: 'sessions-per-second-slot', unit: 'count', rscId: 'SESSIONS_PER_SECOND' },
  { id: 'BYTES_IN', scopedSlot: 'bytes-in-slot', unit: 'bytes', rscId: 'BYTES_IN' },
  { id: 'BYTES_OUT', scopedSlot: 'bytes-out-slot', unit: 'bytes', rscId: 'BYTES_OUT' },
  { id: 'PACKETS_IN', scopedSlot: 'packets-in-slot', unit: 'bytes', rscId: 'PACKETS_IN' },
  { id: 'PACKETS_OUT', scopedSlot: 'packets-out-slot', unit: 'bytes', rscId: 'PACKETS_OUT' },
];

export default {
  name: 'WL4Session',
  mixins: [analysisTableMixin],
  components: {
    WLfourSessionSettingsButton,
    WPerfAnalysisTimeInfo,
    WResourceComparePeriodPopup,
  },
  data() {
    return {
      chartValueColumns,
      comparePeriodRscInfoList: [],
      loading: false,
      tableData: [],
      checkDatetime: null,
      columnDefault,
      columns: [
        {
          prop: 'serverType',
          label: '종류',
          headerAlign: 'center',
          formatter: this.formatterServerType,
          // filterMultiple: false,
          // filters: [{ text: '가상 서버', value: 'V' }, { text: '물리 서버', value: 'R' }],
          // filterMethod: this.filterServerType,
          width: 125,
        },
        {
          prop: 'convertStatusValue',
          width: 55,
          label: '상태',
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'convert-status-slot',
        },
        {
          prop: 'groupName',
          label: '그룹명',
          headerAlign: 'center',
          searchable: true,
          showOverflowTooltip: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'name',
          label: '서버명',
          headerAlign: 'center',
          searchable: true,
          showOverflowTooltip: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'url',
          label: '서비스 (URL)',
          headerAlign: 'center',
          width: 100,
          searchable: true,
          showOverflowTooltip: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipAddress',
          label: 'IP주소',
          headerAlign: 'center',
          width: 120,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'port',
          label: '포트',
          headerAlign: 'center',
          searchable: true,
          width: 55,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'protocol',
          label: '프로토콜',
          headerAlign: 'center',
          searchable: true,
          width: 70,
          formatter: this.formatterProtocol,
        },
        {
          prop: 'metric',
          label: '로드밸런싱 모드',
          headerAlign: 'center',
          searchable: true,
          width: 120,
          formatter: this.formatterMetric,
        },
        {
          prop: 'weight',
          label: '가중치',
          headerAlign: 'center',
          width: 60,
          formatter: this.formatterWeight,
        },
        {
          prop: 'sessionsRatio',
          label: '세션분산비율',
          headerAlign: 'center',
          // align: 'center',
          scopedSlot: 'sessions-ratio-slot',
        },
        {
          prop: 'currentSessions',
          label: '세션개수',
          headerAlign: 'center',
          width: 70,
          scopedSlot: 'current-sessions-slot',
          // formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'sessionUserate',
          label: '세션사용률',
          headerAlign: 'center',
          align: 'center',
          width: 75,
          scopedSlot: 'session-userate-slot',
        },
        {
          prop: 'sessionsPerSecond',
          label: 'CPS',
          headerAlign: 'center',
          width: 50,
          scopedSlot: 'sessions-per-second-slot',
          // formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          label: 'Bytes',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'BYTES_IN',
              label: 'IN',
              headerAlign: 'center',
              width: 80,
              scopedSlot: 'bytes-in-slot',
              // formatter: this.convertBytesValue,
            },
            {
              prop: 'BYTES_OUT',
              label: 'OUT',
              headerAlign: 'center',
              width: 80,
              scopedSlot: 'bytes-out-slot',
              // formatter: this.convertBytesValue,
            },
          ],
        },
        {
          label: 'Packets',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'PACKETS_IN',
              label: 'IN',
              headerAlign: 'center',
              width: 80,
              scopedSlot: 'packets-in-slot',
              // formatter: this.convertCountValue,
            },
            {
              prop: 'PACKETS_OUT',
              label: 'OUT',
              headerAlign: 'center',
              width: 80,
              scopedSlot: 'packets-out-slot',
              // formatter: this.convertCountValue,
            },
          ],
        },
      ],
      showSearchTool: false,
    };
  },
  methods: {
    /**
     * L4 세션 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      this.tableData = [];
      const params = {
        objId: this.selectedNode.obj.objId,
        objCompanyId: this.selectedNode.obj.objCompanyId,
      };
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'NMS';
        this.loading = true;
        netdeviceTableInfoAPI.getL4SessionList(params).then((response) => {
          if (response.data.success === true) {
            const snapshotData = response.data.data;
            this.tableData = isNil(snapshotData.snapshotDoc) ? [] : this.createL4SessionTableData(snapshotData.snapshotDoc);
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = true;
        netdeviceTableInfoAPI.getCurrentL4SessionList(params).then((response) => {
          if (response.data.success === true) {
            this.tableData = isNil(response.data.data) ? [] : this.createL4SessionTableData(response.data.data);
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'L4 세션', false));
    },
    /**
     * 가상서버와 물리서버를 하나의 배열로 가공하여 반환한다.
     * @author Ju
     * @param  {[type]} datas [description]
     * @return {[type]}       [description]
     */
    createL4SessionTableData(datas) {
      const tableData = [];
      forEach(datas, (virtual) => {
        virtual.serverType = 'V';
        tableData.push(virtual);
        if (!isEmpty(virtual.slbRealConfigurationList)) {
          forEach(virtual.slbRealConfigurationList, (real) => {
            real.serverType = 'R';
            // tableData.push(real);
          });
        }
      });
      return tableData;
    },
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    getStatusString(value) {
      switch (value) {
        case 'N': return '정상';
        case 'Y': return '장애';
        default: return '미수집';
      }
    },
    formatterServerType(row) {
      switch (row.serverType) {
        case 'R': return '물리서버';
        case 'V': return '가상서버';
        default: return EMPTY_TEXT;
      }
    },
    // filterStatus(value, row) {
    //   return row.status === value;
    // },
    filterServerType(value, row) {
      return row.serverType === value;
    },
    formatterFileEmpty(row, col) {
      if (isNil(row[col])) {
        return EMPTY_TEXT;
      }
      return row[col];
    },
    formatterProtocol(row) {
      return this.formatterFileEmpty(row, 'protocol');
    },
    formatterMetric(row) {
      return this.formatterFileEmpty(row, 'metric');
    },
    formatterWeight(row) {
      return this.formatterFileEmpty(row, 'weight');
    },
    /**
     * bytes 데이터 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertBytesValue(row, column, value) {
      return convertValuByUnit(value, 'bytes', true, true, true);
    },
    /**
     * count 데이터 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertCountValue(row, column, value) {
      return convertValuByUnit(value, 'count', true, true, true);
    },
    /**
     * % 데이터 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertPercentageValue(value) {
      const result = convertValuByUnit(value, '%', true, true, true);
      return Number.parseFloat(result);
    },
    /**
     * [reloadData 상태 설정 버튼 이벤트 발생시 L4세션 테이블 데이터를 리로드시켜주기 위한 처리]
     * @author {Yang}
     * @return {[type]} [description]
     */
    reloadData() {
      this.$emit('reloadData');
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    changeDataBySession(tableDataList) {
      if (!isEmpty(tableDataList)) {
        const changedTableList = [];
        tableDataList.forEach((snapShotItem) => {
          const realConfigList = snapShotItem.slbRealConfigurationList;
          changedTableList.push(snapShotItem);
          if (!isEmpty(realConfigList)) {
            realConfigList.forEach((configItem) => {
              changedTableList.push(configItem);
            });
          }
        });
        this.tableList = changedTableList;
      } else {
        this.tableList = tableDataList;
      }
    },
    /**
     * Table Row의 클래스명을 반환한다.
     * 가상 서버인 경우 강조 스타일로 표현.
     * @author Ju
     * @param  {[type]} row [description]
     */
    setRowClassName({ row }) {
      return row.serverType === 'V' ? 'point-import' : null;
    },
    /**
     * L4 세션 - cps, 세션 개수, bytes, pps 클릭 시 관련 기간 차트 팝업을 제공한다.
     *
     * @author Song
     * @param  {[type]} row [description]
     */
    onShowChartPopup(row, rscId) {
      const params = [{
        managetypeId: 'NMS',
        rscKey: `${row.ipAddress}:${row.port}`,
        rsctypeId: row.serverType === 'V' ? 'VSLB' : 'RSLB',
        rscId,
        objId: this.selectedNode.obj.objId,
      }];
      this.comparePeriodRscInfoList = params;
      this.$nextTick(() => {
        this.$refs.comparePeriodPopup.open();
      });
    },
    /**
     * L4 가상 서버 expand 이벤트 (현재만)
     * 선택한 가상서버의 하위 물리서버 rscKey를 전달하고 물리서버들의 Bps I/O, Pps I/O 성능을 ELK로 조회하여 치환한다.
     *
     * @author Song
     * @param  {[type]} row [description]
     */
    onClickExpandTable(row, expandFlag) {
      // 최초 펼쳤을 때만 로드하도록 - flag를 row에 넣어서 관리
      if (!row.loadFlag) {
        row.loadFlag = true;
        // 테이블 펼친 이벤트일 경우만 물리서버 성능 데이터(BPS I/O, PPS I/O) 요청
        if (expandFlag && (this.timeType === 'current' || this.operationFlag)) {
          this.loading = true;
          const params = {
            objId: this.selectedNode.obj.objId,
            ipaddress: row.ipAddress,
            port: row.port,
          };
          // 선택한 가상서버의 하위 물리서버 rscKey를 파라미터로 함께 보낸다.
          if (row.slbRealConfigurationList) {
            const rscKeyList = [];
            forEach(row.slbRealConfigurationList, (item) => {
              rscKeyList.push(`${item.ipAddress}:${item.port}`);
            });
            params.rscKeyList = rscKeyList;
            netdeviceTableInfoAPI.getLfourRealServerDataList(params).then((res) => {
              if (res.data.success) {
                // 물리서버 리스트
                forEach(res.data.data, (rscKeyDataList) => {
                  // 물리서버의 자원 리스트
                  forEach(rscKeyDataList, (targetData) => {
                    const realServerRow = row.slbRealConfigurationList.find((findData) => `${findData.ipAddress}:${findData.port}` === targetData.rscKey);
                    realServerRow[targetData.rscId] = !isNil(targetData.rscValue) ? Number(targetData.rscValue) : null;
                  });
                });
              }
            }).catch(() => {
              row.loadFlag = false;
            }).finally(() => {
              this.loading = false;
            });
          }
        }
      }
    },
    /**
     * 검색에서 발견된 row를 펼치는 로직
     *
     * @author najong
     * @param  {[type]} row [description]
     */
    onLoadLocalData(data, states) {
      if (!isEmpty(data) && !isEmpty(states.filters)) {
        const elTable = this.$refs.table.$children[0];
        this.$nextTick(() => {
          data.forEach((row) => {
            elTable.toggleRowExpansion(elTable.data.find((record) => record.ipAddress === row.ipAddress), true);
          });
        });
      }
    },
    lfourDataCheck(data) {
      if (!isNil(data)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style module lang="scss">
.lfour-status {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.status-up {
  background-color: rgb(92, 189, 95);
}
.status-down {
  background-color: rgb(255, 78, 94);
}
.status-mix {
  background-color: rgb(255, 142, 66);
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/L4Session.vue